import { Banner, FlexBox, Text } from '@dixa/lib-shared-habla';
import { IneligibleReasonGeneral } from 'lib-shared-types-api';

import { getGeneralIneligibleText } from '../utils';

type GeneralIneligibleBannerProps = {
  reasons: readonly IneligibleReasonGeneral[];
};

/**
 * Displays a prominent banner when conversation-level ineligible reasons exist.
 * These reasons override all filter-level eligibility and prevent surveys from
 * being sent.
 */
export const GeneralIneligibleBanner = ({
  reasons,
}: GeneralIneligibleBannerProps): JSX.Element => {
  return (
    <Banner
      variant="warning"
      icon="exclamation-triangle-filled"
      headline="Conversation-level blockers"
      description={
        <FlexBox flexDirection="column" gap="100">
          <Text.Paragraph variant="3" subdued>
            The following conditions prevented the survey from being offered,
            regardless of filter matches:
          </Text.Paragraph>

          <FlexBox flexDirection="column" gap="100" padding="0 0 0 300">
            {reasons.map((reason, index) => (
              <Text.Paragraph variant="3" key={index} subdued>
                {index + 1}. {getGeneralIneligibleText(reason)}
              </Text.Paragraph>
            ))}
          </FlexBox>
        </FlexBox>
      }
    />
  );
};
